import type { SocialLinkItemType } from '@/types';
import { Modal, useModalsStack } from '@mantine/core';
import { SocialLinkButton } from '../SocialLinkButton';
import { SocialAuthDialog } from './SocialAuthDialog';
import { SocialErrorDialog } from './SocialErrorDialog';
import { SocialSuccessDialog } from './SocialSuccessDialog';
export type SocialDialogType = ReturnType<typeof useModalsStack<'social-link' | 'success' | 'error'>>;
export type SocialDialogProps = SocialLinkItemType & {
  setActive: (active: boolean) => void;
};
export const SocialDialog: React.FC<SocialDialogProps> = ({
  ...props
}) => {
  const stack = useModalsStack(['social-link', 'success', 'error']);
  return <>
      <Modal.Stack>
        <SocialAuthDialog stack={stack} {...props} />
        <SocialSuccessDialog stack={stack} {...props} />
        <SocialErrorDialog stack={stack} {...props} />
      </Modal.Stack>

      <SocialLinkButton w={96} h={40} handleClick={() => stack.open('social-link')} />
    </>;
};